<!-- Time period selection -->
<div style="margin: 5px; font-size: 15px;">{{ labels.period }}</div>
<dx-box direction="row">
  <dxi-item [ratio]="3">
    <dx-tabs class="tabs_daterange" [dataSource]="tabsDateRange" [(selectedIndex)]="tabsDateRangeSelectedIndex" (onSelectionChanged)="tabs_dateRange_onSelectionChanged($event)">
    </dx-tabs>
  </dxi-item>
  <dxi-item [ratio]="1" style="align-self: center">
    <div *ngIf="!intervalSelected">
      <dx-box direction="row">
        <dxi-item [baseSize]="150">
          <dx-text-box class="date-text" [value]="periodText" [readOnly]="true" style="border: thin; height: 45px; margin-left: 14px; text-align-last: center"></dx-text-box>
        </dxi-item>
      </dx-box>
    </div>
    <div *ngIf="intervalSelected">
      <dx-box direction="row" style="margin-left: 4px"
              align="left"
              width="100%">
        <dxi-item [baseSize]="185">
          <dx-date-box [(value)]="dateFrom" displayFormat="dd.MM.yyyy" [height]="47" [max]="dateTo" type="date" (onValueChanged)="onValueChangedFrom($event)"></dx-date-box>
        </dxi-item>
        <dxi-item [baseSize]="185" style="margin-left: 5px">
          <dx-date-box [(value)]="dateTo" [min]="dateFrom" displayFormat="dd.MM.yyyy" [height]="47" type="date" (onValueChanged)="onValueChangedTo($event)"></dx-date-box>
        </dxi-item>
      </dx-box>
    </div>
  </dxi-item>
</dx-box>
